import { render, staticRenderFns } from "./WorkTableBodySkeleton.vue?vue&type=template&id=1660f572&scoped=true"
import script from "./WorkTableBodySkeleton.vue?vue&type=script&lang=js"
export * from "./WorkTableBodySkeleton.vue?vue&type=script&lang=js"
import style0 from "./WorkTableBodySkeleton.vue?vue&type=style&index=0&id=1660f572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1660f572",
  null
  
)

export default component.exports